import React from "react";
import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import CustomButton from "../../Button/CustomButton";
import CustomDialog from "../CustomDialog";
import CustomTextField from "../../Input/CustomTextField";
import { tesaBlue, tesaBlue4 } from "../../../styles/colors";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alignRight: {
      float: "right",
    },
    header: {
      marginBottom: theme.spacing(3),
    },
    textField: {
      "& > *": {
        width: "100%",
      },
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    MuiDropzoneArea: {
      "& .MuiDropzoneArea-root": {
        minHeight: 200,
        borderWidth: "2px",
        strokeDasharray: "4 6",
        borderRadius: 0,
        outlineColor: tesaBlue,

        "&.MuiDropzoneArea-active": {
          animation: "none",
          backgroundColor: tesaBlue4,
          backgroundImage: "none",
          borderColor: tesaBlue,
        },

        "& .MuiDropzoneArea-text": {
          fontSize: "16px",
          position: "absolute",
          top: "40%",
          left: "50%",
          transform: "translate(-50%, 0)",
        },

        "& .MuiDropzoneArea-icon": {
          position: "absolute",
          width: "40px",
          height: "40px",
          top: "40%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        },

        "& .MuiDropzonePreviewList-root": {
          paddingLeft: 12,
          position: "absolute",
          bottom: "6%",
        },
      },
    },
  }),
);

const AttachmentDialog: React.FC<any> = (props) => {
  const classes = useStyles(props);
  const {
    fullWidth,
    headline,
    maxWidth,
    open,
    onClose,
    onSubmit,
    actionText,
    onFileSelected,
    onChangeDescription,
    selectedFiles,
  } = props;

  return (
    <CustomDialog fullWidth={fullWidth} maxWidth={maxWidth} onClose={onClose} open={open}>
      <div>
        <Grid container>
          <h2 className={classes.header}>{headline}</h2>
          <Grid item lg={12} md={12} sm={12} xs={12} className={classes.MuiDropzoneArea}>
            <DropzoneArea
              onChange={onFileSelected}
              showAlerts={false}
              maxFileSize={1073741824}
              showPreviewsInDropzone
              useChipsForPreview
              filesLimit={1}
            />
          </Grid>
          <Grid item xs={12} className={classes.textField}>
            <CustomTextField
              label="Description"
              name="description"
              id="description"
              type="description"
              multiline
              rows={3}
              onChange={onChangeDescription}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomButton
              className={classes.alignRight}
              primary
              text={actionText.toUpperCase()}
              type="submit"
              onClick={onSubmit}
              disabled={selectedFiles?.length === 0}
            />
          </Grid>
        </Grid>
      </div>
    </CustomDialog>
  );
};

export default AttachmentDialog;
